import getHistoryArchivalState from './get-history-archival-state';

export default namespaceSettings =>
  getHistoryArchivalState(namespaceSettings) === 'Enabled';



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/is-history-archival-enabled.js